/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateOrUpdateBeamAnalysisCorrectionsDto } from './CreateOrUpdateBeamAnalysisCorrectionsDto';
import {
    instanceOfCreateOrUpdateBeamAnalysisCorrectionsDto,
    CreateOrUpdateBeamAnalysisCorrectionsDtoFromJSON,
    CreateOrUpdateBeamAnalysisCorrectionsDtoFromJSONTyped,
    CreateOrUpdateBeamAnalysisCorrectionsDtoToJSON,
} from './CreateOrUpdateBeamAnalysisCorrectionsDto';

/**
 * @type CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections
 * 
 * @export
 */
export type CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections = CreateOrUpdateBeamAnalysisCorrectionsDto;


export function CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSON(json: any): CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections {
    return CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSONTyped(json, false);
}

export function CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...CreateOrUpdateBeamAnalysisCorrectionsDtoFromJSONTyped(json, true) };
    return  CreateOrUpdateBeamAnalysisCorrectionsDtoFromJSONTyped(json, true);
}

export function CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrectionsToJSON(value?: CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfCreateOrUpdateBeamAnalysisCorrectionsDto(value)) {
        return CreateOrUpdateBeamAnalysisCorrectionsDtoToJSON(value as CreateOrUpdateBeamAnalysisCorrectionsDto);
    }

    return {};
}

/**
 * Check if a given object implements the CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections interface.
 */
export function instanceOfCreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections(value: any): value is CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections {
    if (instanceOfCreateOrUpdateBeamAnalysisCorrectionsDto(value)) return true;
    return false;
}

